import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button, Popper, Box, Fade, Paper } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { useTranslate } from 'react-admin';
import UploadFilesPopup from './upload-files-popup';
import ButtonCreateFolder from './button-create-folder';
import Filter from '../filter';
import {
    usePopupState,
    bindToggle,
    bindPopper,
} from 'material-ui-popup-state/hooks'
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'

const useStyles = makeStyles((theme) => ({
    searchGroup: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    btnUpload: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: "0.36px",
        color: "#ffffff",
    }, btnUploadSelect: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: "0.36px",
        color: "#237fc2",
    }, borderButton: {
        borderRadius: '10px',
        border: 'solid 1px #c1e5fa',
        color: "#ffffff"
    },
    borderButtonSelect: {
        borderRadius: '10px',
        border: 'solid 1px #c1e5fa',
        backgroundColor: ' #ffffff',
        color: "#237fc2"
    }

}));

function SearchGroup({ pickerMode, onFilter, setSnackbarMessage, categoryId, getCategory, permissions }) {
    const translate = useTranslate();
    const classes = useStyles();
    const popupState = usePopupState({ variant: 'popper', popupId: 'uploadDialog' });

    const onUploadFilesSuccess = () => {
        const message = translate('pos.categories.uploadFiles.success');
        popupState.close();

        setSnackbarMessage({ message, boldText: '' });
        getCategory(categoryId);

        // Close snackbar message
        setTimeout(() => {
            setSnackbarMessage({ message: '', boldText: '' });
        }, 6000);
    }

    return (
        <Box className={classes.searchGroup}>

            <Filter placeholder='Search images' getList={onFilter} />
            {
                (pickerMode === 'menu' && permissions.isCreate) && (
                    <Box display='flex'>
                        <Button
                            variant="contained"
                            color='primary'
                            className={!popupState.isOpen ? classes.borderButton : classes.borderButtonSelect}
                            // color={isUploadPopoverOpen===false?'primary':'default'}
                            endIcon={<Add></Add>}
                            style={{ marginRight: '1rem' }}
                            {...bindToggle(popupState)}
                        >
                            <Typography className={!popupState.isOpen ? classes.btnUpload : classes.btnUploadSelect}>{translate('pos.categories.uploadBtn')}</Typography>
                        </Button>
                        <CustomPopoverArrow
                            zIndex={1500}
                            popupState={popupState}
                            placement='bottom-end'
                        >
                            <UploadFilesPopup
                                onUploadFilesSuccess={onUploadFilesSuccess}
                                parentId={categoryId}
                                close={() => {
                                    getCategory(categoryId);
                                    popupState.close()
                                }}
                                getCategory={() => getCategory(categoryId)}
                            />
                        </CustomPopoverArrow>
                        <ButtonCreateFolder
                            categoryId={categoryId}
                            getCategory={getCategory}
                            setSnackbarMessage={setSnackbarMessage}
                        />
                    </Box>
                )
            }

        </Box>
    );
}

SearchGroup.propTypes = {
    categoryId: PropTypes.number,
    onFilter: PropTypes.func.isRequired,
    setSnackbarMessage: PropTypes.func.isRequired,
    getCategory: PropTypes.func.isRequired,
};

export default SearchGroup;
